import axios from 'axios'
import router from '../router'

const API_URL = 'https://be.ajakstore.com/api'

const api = axios.create({
  baseURL: API_URL
})

// Interceptor for token
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {                // Tambahkan ini
    return Promise.reject(error)
  }
)

// Interceptor for response
api.interceptors.response.use(
  response => {
    // Kode Anda untuk handle image tetap sama
    if (response.data.data && Array.isArray(response.data.data)) {
      response.data.data = response.data.data.map(product => ({
        ...product,
        image: Array.isArray(product.image) ? product.image : []
      }))
    }
    return response
  },
  error => {               // Tambahkan ini
    if (error.response && error.response.status === 401) {
      // Clear auth data
      localStorage.removeItem('token')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('user')
      
      // Save current location and redirect to login
      const currentPath = router.currentRoute.fullPath
      router.push({
        name: 'LoginView',
        query: { redirect: currentPath !== '/login' ? currentPath : undefined }
      })
    }
    return Promise.reject(error)
  }
)

export const authService = {
  login(credentials) {
    return api.post('/login', credentials)
  },
  register(data) {
    return api.post('/register', data)
  },
  getUserDetail() {
    return api.get('/user/detail')
  }
}

export const acService = {
  getList() {
    return api.get('/product/list')
  },
  getDetail(id) {
    return api.get(`/product/detail/${id}`)
  },
  getListWithSeller() {
    return api.get('/product/list-product-with-seller')
  },
  addProduct(data) {
    return api.post('/product/add', data)
  },
  updateProduct(id, data) {
    return api.post(`/product/update/${id}`, data)
  },
  deleteProduct(id) {
    return api.delete(`/product/delete/${id}`)
  }
}

export const transactionService = {
  getList() {
    return api.get('/transaction/list')
  },
  getDetail(id) {
    return api.get(`/transaction/detail/${id}`)
  },
  getBuyerTransactions() {
    return api.get('/transaction/list_transaction_buyer')
  },
  getSellerTransactions() {
    return api.get('/transaction/list_transaction_seller')
  },
  addTransaction(formData) {
    // Log the FormData before sending
    console.log('Sending FormData to server...')
    
    return api.post('/transaction/add', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Accept': 'application/json',
      },
      // Add this to see the actual request in browser dev tools
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        console.log('Upload Progress:', percentCompleted + '%')
      }
    })
  },
  updatePaymentStatus(transactionId, data) {
    return api.post(`/transaction/update-status-payment/${transactionId}`, data)
  },
  
}

export const userService = {
  updateProfile(formData) {
    return api.post('/user/update-profile', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Accept': 'application/json'
      },
      transformRequest: [function (data) {
        return data; // Don't transform FormData
      }],
      // onUploadProgress: (progressEvent) => {
      //   const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      //   // console.log('Upload progress:', percentCompleted + '%');
      // }
    });
  },
  changePassword(passwordData) {
    return api.post('/user/change-password', {
      current_password: passwordData.current_password,
      new_password: passwordData.new_password,
      new_password_confirmation: passwordData.new_password_confirmation
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    }).then(response => {
      if (response.data.success) {
        return response.data;
      } else {
        throw new Error(response.data.message || 'Password change failed');
      }
    }).catch(error => {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || 'An error occurred while changing the password');
      }
      throw error;
    });
  }
}

export const formatDate = (dateString) => {
  const options = { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric'
  }
  return new Date(dateString).toLocaleDateString('id-ID', options)
}

export const getStatusLabel = (status) => {
  switch(status) {
    case 1:
      return 'Pending'
    case 2:
      return 'Paid'
    case 3:
      return 'Complete'
    default:
      return 'Unknown'
  }
}

export default api